import {graphql, withApollo} from 'react-apollo';
import gql from 'graphql-tag';
import {compose} from 'redux';
import {withAuth} from '../../../components/auth';
import {query} from './with-tripboard-query';
import {connect} from 'react-redux';

const updateTripBoardName = gql`
mutation updateTripBoardName($hav: String!, $tripBoardUuid: String!, $name: String!) {
    updateTripBoardName(hav: $hav, tripBoardUuid: $tripBoardUuid, name: $name)
}`;

const props = ({mutate, ownProps: {client, hav, boardId, currency} = {}}) => ({
    rename: (tripBoardUuid, name) => mutate({
        variables: {
            hav,
            tripBoardUuid,
            name
        },
        update: (proxy) => {
            const variables = {
                hav,
                tripBoardUuid: boardId,
                currency
            };
            try {
                const data = proxy.readQuery({query, variables});
                // remove listing from cache
                if (data.tripBoard) {
                    data.tripBoard.name = name;
                }
                proxy.writeQuery({query, variables, data});
            } catch (err) {
                /* we can't read or write the cache for some reason, silently swallow
                and try to refetch the query from network in the refetchQueries function */
            }
        },
        refetchQueries: [{
            query,
            variables: {
                hav,
                tripBoardUuid,
                currency
            }
        }],
        optimisticResponse: {
            updateTripBoardName: true
        }
    }).catch(() => {
        // VERY HACKY manually set the cache in case something blows up bad server side.
        // TODO: remove when rename query does not error because of v1 issues
        const variables = {
            hav,
            tripBoardUuid: boardId,
            currency
        };
        const data = client.readQuery({query, variables});

        // rename tripboard
        if (data.tripBoard) {
            data.tripBoard.name = name;
        }
        client.writeQuery({query, variables, data});
    })
});
const mapStateToProps = (state) => {
    return {
        currency: state && state.system && state.system.currency || 'USD'
    };
};

const withRenameTripboard = compose(
    withAuth, // hav is extracted from auth context for use in query
    withApollo,
    connect(mapStateToProps),
    graphql(updateTripBoardName, {props})
);

export default withRenameTripboard;



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/with-rename-tripboard.js